import PropTypes from 'prop-types';
export var normalizeTime = function normalizeTime(t) {
  return isFinite(t) ? "".concat(t, "ms") : t;
};
export var directionType = PropTypes.oneOf(['normal', 'reverse', 'alternate', 'alternate-reverse']);
export var fillModeType = PropTypes.oneOf(['none', 'forwards', 'backwards', 'both']);
export var timeType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
export var componentType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);